import { render } from "./ImportProgressComponent.vue?vue&type=template&id=8a9b5522"
import script from "./ImportProgressComponent.vue?vue&type=script&lang=js"
export * from "./ImportProgressComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__